




























































































import { defineComponent, ref } from '@vue/composition-api';
import { AddIcon, CheckIcon, CloseIcon } from 'tdesign-icons-vue';
export default defineComponent({
  name: 'BaseSelect',
  inheritAttrs: false,
  components: {
    AddIcon,
    CloseIcon,
    CheckIcon,
  },
  props: {
    options: {
      type: Array,
      default: [],
      required: true,
    },
    maxlength: {
      type: Number,
      default: 15,
    },
    customObj: {
      type: Object,
    },
    needCustom: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, context) {
    const editOrCreateNamed = ref('create');
    const newNamedOption = ref('');
    const mehotds = {
      onAddNamedOption() {
        editOrCreateNamed.value = 'edit';
      },
      onCancelNamedOption() {
        newNamedOption.value = '';
        editOrCreateNamed.value = 'create';
      },
      onConfirmNamedOption() {
        if (!newNamedOption.value.trim()) return;
        editOrCreateNamed.value = 'create';
        context.emit('onConfirm', newNamedOption.value.trim());
        newNamedOption.value = '';
      },
      visibleChange(visible: boolean) {
        if (visible) {
          editOrCreateNamed.value = 'create';
        }
        newNamedOption.value = '';
      },
    };
    return {
      newNamedOption,
      editOrCreateNamed,
      ...mehotds,
    };
  },
});
